class RecipientForm extends HTMLElement {
  constructor() {
    super();

    this.setupVariables();
    this.setupEvents();
  }

  setupVariables() {
    this.variantId = this.getAttribute("data-selected-variant-id");
    this.currencySymbol = this.getAttribute("data-currency-symbol");
    this.formEl = this.querySelector("form");
    this.currencies = ['GBP', 'USD', 'EUR', 'CAD', 'AUD', 'DKK', 'CHF'];
  }

  setupEvents() {
    this.formEl.addEventListener("submit", this.handleFormSubmit.bind(this));
    document.addEventListener("variant:changed", this.handleVariantChange.bind(this));
    this.addEventListener('click', this.handleRecipientFormClick.bind(this));
  }

  handleFormSubmit(event) {
    event.preventDefault();

    // Collect form data
    const senderName = event.target.elements.sender_name.value;
    const senderEmail = event.target.elements.sender_email.value;
    const recipientName = event.target.elements.recipient_name.value;
    const recipientEmail = event.target.elements.recipient_email.value;
    const recipientMessage = event.target.elements.recipient_message.value;
    const recipientSendOn = event.target.elements.recipient_send_on.value;
    const variantId = this.variantId;

    // Add product to the cart with additional properties
    const data = {
      items: [
        {
          id: variantId, // Get the variant ID dynamically
          quantity: 1,
          properties: {
            "Sender name": senderName,
            "Sender email": senderEmail,
            "Recipient name": recipientName,
            "Recipient email": recipientEmail,
            Message: recipientMessage,
            __shopify_send_gift_card_to_recipient: "on",
            "Send on": recipientSendOn,
          },
        },
      ],
      // sections: "mini-cart",
    };

    // Send AJAX request to Shopify cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data)
    })
      .then((response) => response.json())
      .then((data) => {
        this.closeRecipientForm();
        this.refreshCart();
        this.openCartDrawer();
      })
      .catch((error) => {
        console.log("Waxlondon:", "Error:", error);
      });
  }

  setSidebarCartHtml(el) {
    const sidebarCartEl = document.querySelector('#sidebar-cart');
    if (sidebarCartEl) {
      sidebarCartEl.replaceWith(el);
    }
  }

  setCartCount(val) {
    const cartCountEl = document.querySelector('header#section-header .Header__Icon[href="/cart"] .Header__CartDot')

    if (cartCountEl) {
      cartCountEl.textContent = val;
    }
  }

  formatMoney(cents, currency = 'USD', fullLocale = 'en-US') {
    const price = cents / 100; // Convert cents to dollars (or appropriate currency unit)

    // Check if the Intl.NumberFormat API is supported
    if (typeof Intl !== "undefined" && Intl.NumberFormat) {
      let formattedPrice = new Intl.NumberFormat(fullLocale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: price % 1 === 0 ? 0 : 2, // No decimals for whole numbers, two decimals for others
        maximumFractionDigits: 2, // Cap at two decimal places
      }).format(price);

      return formattedPrice;
    } else {
      // Fallback formatting if Intl is not supported
      return `${currency} ${price.toFixed(price % 1 === 0 ? 0 : 2)}`;
    }
  }

  handleVariantChange(event) {
    console.log("Waxlondon:", "variant:changed event", event);

    this.variantId = event.detail.variant.id;
    const variantPrice = event.detail.variant.price;
    const variantTitle = event.detail.variant.title;

    const recipientFormPriceEl = this.querySelector(
      ".c-recipient-form__title-price"
    );

    if (recipientFormPriceEl && variantPrice) {
      const currency = window.Shopify.currency.active;
      const locale = window.Shopify.locale;
      const country = window.Shopify.country;
      const fullLocale = `${locale}-${country}`;
      const formattedPrice = formatMoney(variantPrice, currency, fullLocale);
      recipientFormPriceEl.textContent = formattedPrice;
    }
  }

  handleRecipientFormClick(event) {
    // Listen recipient form close icon click
    if (
      event.target.closest('.c-recipient-form__close-icon') || 
      event.target.classList.contains('c-recipient-form-wrapper')) {
      this.closeRecipientForm()
    }      
  }

  closeRecipientForm() {
    document.querySelector('.c-recipient-form-wrapper')?.classList.add('is-hidden')
  }

  openRecipientForm() {
    document.querySelector('.c-recipient-form-wrapper')?.classList.remove('is-hidden')
  }

  refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }

  openCartDrawer() {
    document.querySelector('header#section-header .Header__Icon[href="/cart"]')?.click()
  }

  connectedCallback() {}
  disconnectedCallback() {}
}

if (!customElements.get("recipient-form")) {
  customElements.define("recipient-form", RecipientForm);
}
